import {
  BindingCreateRequest,
  BindingWebService,
  RestfulBindingWebService
} from 'ws/BindingWebService';

export interface BindingManager {
  createBinding(
    channel: string,
    channelGroupId: number | undefined,
    createRequest: BindingCreateRequest
  ): Promise<void>;
  updateBinding(
    channel: string,
    channelGroupId: number | undefined,
    updateRequest: BindingCreateRequest
  ): Promise<void>;
}

export class DefaultBindingManager implements BindingManager {
  webService: BindingWebService;

  constructor(webService: BindingWebService = new RestfulBindingWebService()) {
    this.webService = webService;
  }

  async createBinding(
    channel: string,
    channelGroupId: number | undefined,
    createRequest: BindingCreateRequest
  ): Promise<void> {
    return this.webService.createBinding(
      channel,
      channelGroupId,
      createRequest
    );
  }

  async updateBinding(
    channel: string,
    channelGroupId: number | undefined,
    updateRequest: BindingCreateRequest
  ): Promise<void> {
    return this.webService.updateBinding(
      channel,
      channelGroupId,
      updateRequest
    );
  }
}
